export const CharitiesHeaderImage = {
  header: {
    image: 'assets/hub/charity-banner.png',
    title: 'نیکوکاری',
    subTitle: 'در ساختن دنیای بهتر سهیم باش!',
  },
};
